import { PageReqSchema } from '@/types/axios/public-json-structure'
import request from '@/utils/request'
import { IMtList, IMtOnline, IMtRes, ILanguageTypeRes } from './type'

// 查询翻译类型
export const queryTypeAPI = () => {
  return request.get<ILanguageTypeRes[]>(`/api/translate/language/type`)
}

// 创建任务
export const createTaskAPI = (params: IMtList.ICreateTaskReq) => {
  return request.post<IMtList.IMtListRes[]>(`/api/translate/create`, undefined, { params })
}

// 获取翻译进度
export const getProgressAPI = (params: { id: string }) => {
  return request.get<IMtList.IProgressRes[]>(`/api/translate/progress`, { params, showMessageOnError: false })
}

// 批量导出
export const exportTaskAPI = (params: { id: string }) => {
  return request.get(`/api/translate/export`, { params, responseType: 'blob' })
}

// 批量删除任务
export const deleteTaskAPI = (p: string[]) => {
  return request.post(`/api/translate/delete`, p)
}

// 重试
export const reTryAPI = (p: string) => {
  return request.post(`/api/translate/retry?id=${p}`)
}

// 实时翻译
export const onLineTranslateAPI = (p: IMtOnline.ITranslateReq) => {
  return request.post(`/api/translate/online/translate`, p, { showMessageOnError: false })
}

// 查询翻译结果
export const getResultAPI = (p: IMtRes.IMtResReq) => {
  return request.get<IMtRes.ITranslateRes>(`/api/translate/result`, { params: p })
}

// 更新翻译结果
export const updateResultAPI = (p: IMtRes.IMtUpdateReq) => {
  return request.post(`/api/translate/update`, p.content, { params: { id: p.id } })
}

// 翻译结果列表
export const getResultList = (params: PageReqSchema) => {
  return request.get('/api/translate/page', { params })
}
